import { Injectable } from '@angular/core';
import { UserBusiness } from '@app/models/user-business';
import { UserBusinessService  } from '@app/services/api/user-business.service';
import {
    UserBusinessActionTypes,
    Load,
    LoadFail,
    LoadSuccess,
} from '@core/actions/user-business.actions';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';



@Injectable()
export class UserBusinessEffects {

    
    constructor(
	private actions$: Actions,
	private userBusinessesApi: UserBusinessService
    ) {}
}
